import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import vuetify from './vueify'
import router from './router'
import { createPinia, Pinia } from "pinia";
import auth from "./plugins/auth.ts";

const pinia: Pinia = createPinia();

const app = createApp(App);

app.use(vuetify)
app.use(pinia)
app.use(router)
app.use(auth, {router});

// app.use(VueTelInput, {mode: 'auto'});
app.mount("#app");
